import { useState, useEffect } from 'react';
import { useAuth0 } from './useAuth0';
import api from '../services/api';

export const useSubscription = () => {
  const { isAuthenticated } = useAuth0();
  const [tier, setTier] = useState('free');
  const [status, setStatus] = useState('none');
  const [isPremium, setIsPremium] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isAuthenticated) {
      setLoading(false);
      return;
    }
    fetchStatus();
  }, [isAuthenticated]);

  const fetchStatus = async () => {
    try {
      const response = await api.get('/v1/subscription/status');
      const data = response.data;
      setTier(data.tier || 'free');
      setStatus(data.status || 'none');
      setIsPremium(data.isPremium || false);
    } catch (err) {
      console.error('Failed to fetch subscription status:', err);
      setTier('free');
      setIsPremium(false);
    } finally {
      setLoading(false);
    }
  };

  const subscribe = async (planType = 'monthly') => {
    try {
      const response = await api.post('/v1/subscription/checkout', { planType });
      window.location.href = response.data.url;
    } catch (err) {
      console.error('Failed to create checkout session:', err);
    }
  };

  const manageSubscription = async () => {
    try {
      const response = await api.post('/v1/subscription/portal');
      window.location.href = response.data.url;
    } catch (err) {
      console.error('Failed to create portal session:', err);
    }
  };

  return { tier, status, isPremium, loading, subscribe, manageSubscription, refetch: fetchStatus };
};